import React, {useContext, useEffect} from 'react';
import './CustomToast.css'
// 引入 ToastContext
import {ToastContext} from './ToastProvider';

type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastItem {
    id: string;
    type: ToastType;
    message: string;
}

const CustomToast: React.FC<ToastItem> = ({id, type, message}) => {
    const {removeToast} = useContext(ToastContext);

    const defaultToastStyles: Record<ToastType, React.CSSProperties> = {
        success: {backgroundColor: '#4CAF50', color: '#FFFFFF'},
        error: {backgroundColor: '#FF5252', color: '#FFFFFF'},
        info: {backgroundColor: '#2196F3', color: '#FFFFFF'},
        warning: {backgroundColor: '#FFC107', color: '#212121'},
    };

    useEffect(() => {
        // 设置定时器来移除 Toast
        const timeoutId = setTimeout(() => {
            removeToast(id);
        }, 3000); // 3秒后自动关闭

        return () => clearTimeout(timeoutId);
    }, [id, removeToast]);

    return (
        <div className="custom-toast-container" onClick={() => removeToast(id)}>
            <div  className="custom-toast my-roboto-medium custom-toast" style={{...defaultToastStyles[type]}}>
                {message}
            </div>
        </div>
    );
};

export default CustomToast;